<template>
    <div>
        <div class="row">
            <div class="col-4 text-left">False</div>
            <div class="col-4 text-center">Undecided</div>
            <div class="col-4 text-right">True</div>
        </div>


        <input type="range" class="slider mb-4" min="-1" max="1"
               :value="veracity" step="0.01" data-toggle="tooltip" data-html="true"
               data-placement="bottom" :disabled="!isEnabled" @input="$emit('input', Number($event.target.value))"/>
    </div>
</template>

<script>
    export default {
        name: "VeracitySlider",
        props: {
            veracity: {
              type: Number,
              default: 0
            },
            isEnabled: {
                type: Boolean,
                default: false,
            }
        },
    }
</script>

<style scoped>

</style>
